import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean, text } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Radio', () => ({
		template: `
		<div>
			<dms-radio v-bind="{disabled}" :label="label_1" :radioLabel="1" :value.sync="value" />
			<dms-radio v-bind="{disabled}" :label="label_2" :radioLabel="2" :value.sync="value" />
		</div>
		`,
		data() {
			return {
				value: null,
			};
		},
		props: {
			label_1: {
				default: text('Hodnota 1', 'Souhlasím'),
			},
			label_2: {
				default: text('Hodnota 2', 'Nesouhlasím'),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
